/**
 * Common texts - what is CamAPS FX
 */
export const whatIsCamAPSFX = {

    linkFindOutMore: 'Saiba mais',
    body:
        '<h2>O que é o CamAPS FX?</h2> ' +
        '<p> ' +
        '    O CamAPS FX é uma aplicação móvel para gerir os níveis de glicose em ' +
        '    pessoas com diabetes tipo 1, a partir de um ano de idade, através de ' +
        '    uma abordagem avançada e adaptativa de circuito fechado híbrido. ' +
        '</p>'
};

/**
 * Common texts - user reviews intro
 */
export const userReviewsIntro = {
    linkMoreReviews: 'Mais histórias',
    readMore: 'Ler mais',
    header:
        'Histórias de utilizadores',
    text:
        'Pessoas reais. Experiências reais.'
};
